var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-stepper',{attrs:{"min":_vm.min,"max":_vm.max,"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }